module.exports = __webpack_public_path__ + "forum.603064a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/forum.png
// module id = 350
// module chunks = 0